import React from 'react';

import {ProjectAttributeFilterValue} from 'nav/sidepanel/listing/ProjectListingConstants';
import DropdownFilterForm, {getFilterText} from 'search/filters/base/DropdownFilterForm';
import {FilterKey, SingleValueFilterWithDefault} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export interface ProjectAttributeFilter extends SingleValueFilterWithDefault {
  key: FilterKey.PROJECT_ATTRIBUTE;
  value: ProjectAttributeFilterValue;
}

interface Props extends BaseFilterFormProps {
  filter: ProjectAttributeFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: ProjectAttributeFilter) => void;
}

export default function ProjectAttributeFilterForm(props: Props): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const optionDatas = [
    {name: 'All active', value: null},
    {name: 'Starred', value: ProjectAttributeFilterValue.STARRED},
    {name: 'Hidden', value: ProjectAttributeFilterValue.HIDDEN},
    {name: 'Archived', value: ProjectAttributeFilterValue.ARCHIVED},
  ];
  return (
    <DropdownFilterForm
      {...skeletonProps}
      value={props.filter.value}
      isMulti={false}
      dropdownToggleText={getFilterText(optionDatas, props.filter) || 'All active'}
      onChangeValue={(value: ProjectAttributeFilterValue) => {
        props.onChangeFilter({...props.filter, value});
      }}
      optionDatas={optionDatas}
      filterStyle={props.filterStyle}
    />
  );
}
